module.exports = "/images/points_triangle.svg?6633eb9bb74d4585a95f5f34402d4e18";


//////////////////
// WEBPACK FOOTER
// ./resources/images/points_triangle.svg
// module id = PiMr
// module chunks = 0